var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicyBenefitIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 60,
    viewBox: "0 0 84 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 60,
    rx: 29.4545,
    fill: "#D8ECED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7153_14751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.8831 39.8502V16.3501H28.502V41.0574C28.502 42.4886 29.6637 43.6503 31.0948 43.6503H51.8866",
    stroke: "#0D4248",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0938 43.6502C32.5109 43.6502 33.0533 42.5025 33.0533 41.0854V39.8467H55.4967V40.0391C55.4967 42.0336 53.8801 43.6502 51.8856 43.6502",
    stroke: "#0D4248",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5766 21.3747C48.5766 22.8339 47.3939 24.0166 45.9348 24.0166C44.4757 24.0166 43.293 22.8339 43.293 21.3747C43.293 19.9156 44.4757 18.7329 45.9348 18.7329C47.3939 18.7329 48.5766 19.9156 48.5766 21.3747Z",
    stroke: "#0D4248",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5771 21.3745V28.1523L45.9352 26.3713L43.2969 28.1523V21.3745",
    stroke: "#0D4248",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5653 20.7236H35.5358C34.836 20.7236 34.2656 21.2905 34.2656 21.9938C34.2656 22.6936 34.8325 23.264 35.5358 23.264H36.2986C36.9984 23.264 37.5688 23.8309 37.5688 24.5342V24.7896C37.5688 25.4894 37.0019 26.0598 36.2986 26.0598H34.2691",
    stroke: "#0D4248",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9141 27.8342V26.0566",
    stroke: "#0D4248",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9141 20.7236V19.3975",
    stroke: "#0D4248",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2656 31.1514H48.577",
    stroke: "#0D4248",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2656 34.5488H48.577",
    stroke: "#0D4248",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2656 37.4287H48.577",
    stroke: "#0D4248",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7153_14751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.6956,
    height: 28,
    fill: "white",
    transform: "translate(28.1523 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyBenefitIcon1);
export default __webpack_public_path__ + "static/media/policy-benefit-icon1.c0f3558c0d31a6ca04a6c1680e65cc34.svg";
export { ForwardRef as ReactComponent };